function Project() {
  const projects = [
    { number: "01", title: "Split", type: "Product · OCR · Applied AI", description: "A receipt-to-settlement workflow that uses optical character recognition and language models to turn a photo into an itemized, shareable bill.", note: "Nelson Center for Entrepreneurship Award · Hack@Brown 2023", href: "https://github.com/exing1/split-it" },
    { number: "02", title: "Deblur", type: "Computer Vision · Optimization", description: "Text deblurring through blur-kernel estimation, using L₀-regularized intensity and gradient priors with alternating minimization.", note: "Research implementation", href: "https://github.com/zhouzypaul/deblur" },
    { number: "03", title: "Train", type: "Computer Vision · Human Movement", description: "A real-time coaching tool that uses pose estimation and joint-angle similarity to measure exercise accuracy and effectiveness.", note: "OpenPose-powered prototype", href: "https://github.com/seanxzhan/TaiChiMaster" },
  ];

  return (
    <section className="section projects" id="projects">
      <div className="section-label"><span>03</span><p>Selected work</p></div>
      <div className="section-body project-list">
        <div className="project-heading"><h2>A few things I’ve built.</h2><p>Experiments in applied AI, computer vision, and useful software.</p></div>
        {projects.map((project) => (
          <a className="project-row" href={project.href} target="_blank" rel="noreferrer" key={project.title}>
            <span className="project-number">{project.number}</span>
            <div className="project-title"><h3>{project.title}</h3><p>{project.type}</p></div>
            <div className="project-description"><p>{project.description}</p><span>{project.note}</span></div>
            <span className="project-arrow" aria-hidden="true">↗</span>
          </a>
        ))}
      </div>
    </section>
  );
}

export default Project;
